import React from 'react';
import _ from 'lodash';
import { Tooltip } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import HourGlass from 'images/icons/hourglass.svg';
import Text from 'components/base/Text';
import Loading from 'images/loading.gif';
import styled from 'styled-components';
import moment from 'moment';
import { DATE_FORMAT } from 'common/constants/constants';
const Loader = styled.img`
  width: 3rem;
`;
const LoaderWrapper = styled(Flex)`
  background-color: #eeeaff;
  width: fit-content;
  align-items: center;
  height: 3rem;
  padding: 0 1rem;
  border-radius: 4px;
  ${({ isExtendedView }) =>
    `margin-bottom: ${isExtendedView ? '0' : '0.5rem'};`}
`;
const LoadingProjectData = ({ projectState, isExtendedView }) => {
  const editorName = _.get(projectState, 'editor', null);
  const editTime = _.get(projectState, 'editTime', Date.now());

  return (
    <Tooltip
      data-testid='loading-project-tooltip'
      placement='top'
      title={
        <Flex padding='tooltip'>
          <img src={HourGlass} alt='' />
          <Flex direction='column' ml='medium'>
            <Text weight='500' size='large' mb='0.8rem'>
              Loading new project data
            </Text>
            <Text color='shuttleGray' size='medium' mb='0.2rem'>
              This project was edited by:
            </Text>
            <Text color='shuttleGray' size='medium' mb='0.2rem'>
              {editorName}, {moment(editTime).format(DATE_FORMAT)}
            </Text>
            <Text color='shuttleGray' size='medium'>
              Changes will appear soon...
            </Text>
          </Flex>
        </Flex>
      }
    >
      <LoaderWrapper
        isExtendedView={isExtendedView}
        data-testid='project-is-updating'
      >
        <Loader src={Loading} />
        <Text ml='0.5rem' color='darkBlue'>
          UPDATING PROJECT DATA
        </Text>
      </LoaderWrapper>
    </Tooltip>
  );
};

export default LoadingProjectData;
